/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx } from "react/jsx-runtime";
// Local
import { withStandardComponentWrapper } from 'helpers/HOC';
import { tv } from 'tailwind-variants';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const Divider = (props)=>{
    const isEditing = useIsEditing();
    const { RenderingIdentifier } = props?.params || {};
    const { base } = TAILWIND_VARIANTS();
    /*
   * RENDERING
   */ return /*#__PURE__*/ _jsx("div", {
        "data-component": "authorable/shared/layout/divider",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        ...getTestProps(`component-divider-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx("div", {
            className: base()
        })
    });
};
export const Default = withStandardComponentWrapper(Divider, false);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'w-full',
            'h-px',
            'bg-color-border-border'
        ]
    }
});
